module.exports = __webpack_public_path__ + "static/media/Trip Report Icon.f151c01b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Trip Report Icon.png
// module id = 1274
// module chunks = 0